import { PlayerQueryParams } from '@vimeo/embed-player';
import { translate } from '@vimeo/i18n-runtime';

import { HoverStateType } from './types';

export const DEFAULT_SHOWCASE_PLAYER_EMBED_OVERRIDE_QUERY: PlayerQueryParams = {
  /** Player right side dock buttons should be hidden, use ActionBar instead */
  like: 0,
  watch_later: 0,
  share: 0,
  ask_ai: 0,

  /** Player left side widgets should be hidden, use VideoDetails instead */
  title: 0,
  byline: 0,
  portrait: 0,
  badge: 0,

  /** Keep other appearance unified and should all be showing */
  play_button_position: 'bottom',
  progress_bar: 1,
  volume: 1,
  quality_selector: 1,
  speed: 1,
  fullscreen: 1,
  vimeo_logo: 0,

  /** Skip player backend applied legacy clip player appearance */
  force_embed: 1,
};

const uploaderDetailsDisplayConfig = {
  showByline: true,
  showCard: true,
  showProfile: true,
  showFollow: false,
  showProfileLink: false,
};

export const getUploaderDetailsDisplayConfig = (
  overrides?: Partial<typeof uploaderDetailsDisplayConfig>,
) => ({ ...uploaderDetailsDisplayConfig, ...overrides });

export const FALLBACK_THUMBNAIL_URL = 'https://i.vimeocdn.com/video/default-2308240_360x203.jpg';
export const FALLBACK_THUMBNAIL_URL_2X = 'https://i.vimeocdn.com/video/default-2308240_640x360.jpg';

export const playerGridSizeMap = {
  s: { base: 1, lg: 2, xl: 3, '2xl': 4 },
  m: { base: 1, lg: 2, xl: 3, '2xl': 4 },
  l: { base: 1, xl: 2, '2xl': 3 },
  xl: { base: 1, '2xl': 2 },
};

export const thumbnailGridSizeMap = {
  s: { base: 1, md: 2, lg: 3, xl: 4, '2xl': 5 },
  m: { base: 1, lg: 2, xl: 3, '2xl': 4 },
  l: { base: 1, xl: 2, '2xl': 3 },
  xl: { base: 1, '2xl': 2 },
};

export const ALIGNMENT_VALUES = {
  center: 'center',
  right: 'flex-end',
  left: 'flex-start',
} as const;

export const SHOWCASE_BASE_URL = '/manage/showcases/';

export const HOVER_STATE_CONFIG = {
  navigation: {
    title: translate('Navigation'),
    items: [{ label: translate('Customize'), route: '/layout/navigation' }],
  },
  banner: {
    title: translate('Banner'),
    items: [{ label: translate('Customize'), route: '/layout/featured' }],
  },
  playlist: {
    title: translate('Video grid'),
    items: [
      { label: translate('Manage videos'), route: '/layout/video-grid' },
      { label: translate('Customize'), route: '/layout/video-grid?tab=customization' },
    ],
  },
};

export const getHoverStateItems = (type: HoverStateType, isPlaybackPath?: boolean) => {
  if (type === 'playlist' && isPlaybackPath) {
    const config = { ...HOVER_STATE_CONFIG[type] };
    config.items = [config.items[0]];
    return config;
  }
  return HOVER_STATE_CONFIG[type];
};
